import { ConversationType } from '../enums/chat';

export const generateEntityId = (
    conversationType: ConversationType,
    entityRefId: string | null
): string => {
    if (!entityRefId || entityRefId === '') {
        return '';
    }
    return conversationType + '-' + entityRefId;
};

export const parseEntityId = (
    entityId: string
): {
    conversationType: ConversationType | null;
    entityRefId: string | null;
} => {
    if (!entityId) {
        return { conversationType: null, entityRefId: null };
    }
    const parts = entityId.split('-');
    if (parts.length < 2) {
        return { conversationType: null, entityRefId: null };
    }
    const conversationType = parts[0] as ConversationType;
    const entityRefId = parts[1];

    return { conversationType, entityRefId };
};
